exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.h-inventory[data-v-5275dc0e] {\n  padding-left: 0;\n}\nul.h-inventory > li[data-v-5275dc0e] {\n  list-style: none;\n}\n", ""]);

// exports
